import {
  Avatar,
  Box,
  Button,
  HStack,
  Icon,
  Image,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  RemixiconComponentType,
  RiBox3Line,
  RiShareLine,
} from "@remixicon/react";
import { CardProductMyStoreInterface } from "../../constants/Product";
import { useBorderColor, useDarkWhiteColor } from "../../themes/colors";
import { ProductAdded } from "../card/ProductAdded";

interface Props extends StackProps {
  data?: CardProductMyStoreInterface;
  onClickItem: (
    id: string | number | undefined,
    storePrefix: string,
    storeProduct: string
  ) => void;
  onClickButton?: (
    id: string | number | undefined,
    storePrefix: string,
    storeProduct: string
  ) => void;
  btnText?: string;
  btnIcon?: RemixiconComponentType;
  isDisabled?: boolean;
}

export const CardProductMyStore = ({
  data,
  onClickItem,
  onClickButton,
  btnText = "Bagikan",
  btnIcon = RiShareLine,
  isDisabled = false,
  ...rest
}: Props) => {
  const bgBnw = useDarkWhiteColor();
  const borderColor = useBorderColor();

  const handleClickItem = () => {
    onClickItem(data?.id, `${data?.store_prefix}`, `${data?.slug}`);
  };

  const handleClickButton = (event: any) => {
    event.stopPropagation();
    onClickButton &&
      onClickButton(data?.id, `${data?.store_prefix}`, `${data?.slug}`);
  };

  return (
    <Box
      w={"100%"}
      bg={bgBnw}
      borderWidth={"1px"}
      borderColor={borderColor}
      borderRadius={"md"}
      align={"stretch"}
      cursor={"pointer"}
      onClick={handleClickItem}
      {...rest}
    >
      <Image
        className="ratio-1-1"
        w={"100%"}
        src={
          data?.image ? `${process.env.REACT_APP_MEDIA_URL}${data?.image}` : ""
        }
        alt={data?.name || "Product Image"}
        borderTopRightRadius={"md"}
        borderTopLeftRadius={"md"}
        fallbackSrc="/assets/svg/illustration_empty.svg"
        objectFit={"cover"}
      />

      <VStack p={3} align={"stretch"} gap={1}>
        {data?.category && (
          <HStack>
            <Icon as={RiBox3Line} fontSize={[10, null, 12]} opacity={0.6} />

            <Text
              textStyle={"b-sm"}
              variant={"secondary"}
              noOfLines={1}
              textOverflow={"ellipsis"}
            >
              {data.category}
            </Text>
          </HStack>
        )}

        <Text
          textStyle={"b-reg-sb"}
          noOfLines={1}
          textOverflow={"ellipsis"}
          mt={0.5}
        >
          {data?.name}
        </Text>

        <Text
          textStyle={"b-reg-sb"}
          color={"red.400"}
          noOfLines={1}
          textOverflow={"ellipsis"}
        >
          {data?.price}
        </Text>

        {data?.storeLogo && data.storeName && (
          <HStack mt={2}>
            <Avatar
              name={data.storeName || ""}
              src={
                data.storeLogo
                  ? `${process.env.REACT_APP_MEDIA_URL}${data.storeLogo}`
                  : ""
              }
              size={"xs"}
            />

            <Text
              textStyle={"b-sm-sb"}
              opacity={0.6}
              noOfLines={1}
              textOverflow={"ellipsis"}
            >
              {data.storeName}
            </Text>
          </HStack>
        )}

        {onClickButton ? (
          data?.added === 0 || data?.added === undefined ? (
            <Button
              mt={3}
              size={"sm"}
              borderRadius={"4px"}
              variant={"outline"}
              colorScheme="red"
              leftIcon={btnIcon ? <Icon as={btnIcon} /> : undefined}
              onClick={handleClickButton}
              isDisabled={isDisabled}
            >
              {btnText}
            </Button>
          ) : (
            <ProductAdded mt={5} textStyle="b-sm" />
          )
        ) : null}
      </VStack>
    </Box>
  );
};
